var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('slice-block-grid');
import { breakpoints, theme } from '@shapeable/theme';
import { Grid } from '../elements/grid';
import { useEntity } from '../hooks/use-entity';
import { BlockContent } from './block-content';
export var SliceBlockGridDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BlockStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(8)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-bottom: 0;\n  "], ["\n    padding-bottom: 0;\n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: styled(Grid)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Block: styled(BlockContent)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BlockStyles)
};
export var SliceBlockGrid = function (props) {
  var className = props.className,
    children = props.children;
  var entity = useEntity(props.entity);
  var _a = entity.blocks,
    blocks = _a === void 0 ? [] : _a;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Grid, {
    columns: 3,
    spacing: 8,
    items: blocks.map(function (block) {
      return React.createElement(My.Block, {
        key: block.id,
        entity: block
      });
    })
  }), children);
};
SliceBlockGrid.defaultProps = SliceBlockGridDefaultProps;
SliceBlockGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;